import { clsx } from 'clsx';
import { LIST, MODELS, UTP } from './constants';
import * as styles from './styles.css';
import { TwoUtpBlock } from 'shared/components/TwoUtpBlock';
import { useDeviceType } from '@cian/ui-kit';
import { NavigationButtons } from 'shared/components/NavigationButtons';
import { Wrapper } from 'shared/components/Wrapper';
import { Block } from 'shared/components/Block';
import { Title } from 'shared/components/Title';
import { SubTitle } from 'shared/components/SubTitle';
import { CustomList } from 'shared/components/CustomList';
import { Description } from 'shared/components/Description';
import { Element } from 'react-scroll';
import { ENavigation } from 'shared/types/navigation';
import { BTN_DAILY_LINK, BTN_TECHNOLOGIES_LINK, BTN_TRANSACTIONAL_LINK } from 'shared/constants/links';

export const MediaAdvert: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <Wrapper>
        <Element name={ENavigation.MediaAd}>
          <Block>
            <Title text="Медийная реклама" />
            <Description
              text={[
                {
                  value:
                    'Медийная реклама в Циан работает на охват, привлечение внимания и повышение узнаваемости проектов и предложений застройщиков.',
                },
              ]}
            />
            <Description
              text={[
                { value: 'Что это:', isBold: true },
                { value: ' баннеры, спецпроекты и видеоформаты в выделенных зонах сайта и приложения' },
              ]}
            />
          </Block>
        </Element>
        <Block>
          <SubTitle text="Модели оплаты:" />
          <div className={styles['payment-models']}>
            {MODELS.map(({ text, title, image }, key) => (
              <div className={styles['model']} key={key}>
                <div className={clsx(styles['model-image'], styles[image])} />
                <div className={styles['model-text']}>
                  <span className={styles['bold']}>{title} — </span>
                  {text}
                </div>
              </div>
            ))}
          </div>
        </Block>
        <Block>
          <SubTitle text="Инструменты:" />
          <TwoUtpBlock blocks={UTP} />
        </Block>
        <Block>
          <SubTitle text="Ценность для застройщика:" />
          <CustomList items={LIST} />
          <Description
            text={[
              {
                value:
                  'Медийная реклама усиливает эффективность других каналов: покупатель может впервые увидеть проект на Циан, а затем вернуться через контекстную рекламу или напрямую на сайт девелопера. Чем больше точек контакта с брендом, тем выше вероятность обращения.',
              },
            ]}
          />
        </Block>
        <NavigationButtons
          withOutMarginBottom
          links={[BTN_TECHNOLOGIES_LINK, BTN_TRANSACTIONAL_LINK, BTN_DAILY_LINK]}
        />
      </Wrapper>
    </div>
  );
};
